import { signalStoreFeature, withState } from '@ngrx/signals';

type InitializationState = {
  isInitialized: boolean;
};

export function withAsyncInitialization() {
  return signalStoreFeature(withState<InitializationState>({ isInitialized: false }));
}

export function setInitialized(): InitializationState {
  return { isInitialized: true };
}
